
import Base from './Base';

// 参考
// https://doc.oschina.net/xingchengzushou?t=218314

export default class Order extends Base {
  // 主要以这个接口的order结构为准
  // doc: https://doc.oschina.net/xingchengzushou?t=218314
  schema = {
    id: String,
    order_url: String,
    car_name: String,
    car_image: String,

    days: Number,
    from_date: String,
    to_date: String,
    from_time: Number,
    to_time: Number,

    // 取还车城市
    city: Number,
    city_cn: String,
    dropoff_city: Number,
    dropoff_city_cn: String,

    // 发现行程
    discover_trip: {
      ids: Array,
      more_link: String
    }
  };

  // order.getAll()
  static parseInput(obj = {}) {
    return obj;
  }
}



// WEBPACK FOOTER //
// ./src/models/Order.js